import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: 'Home', id: 'home' },
    { label: 'Leistungen', id: 'leistungen' },
    { label: 'Über uns', id: 'ueber-uns' },
    { label: 'Projekte', id: 'projekte' },
    { label: 'Kontakt', id: 'kontakt' }
  ];

  const services = [
    'Heizungstechnik',
    'Lüftungstechnik',
    'Klimatechnik',
    'Sanitärtechnik',
    'Elektrotechnik'
  ];

  return (
    <footer className="bg-slate-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-lg flex items-center justify-center font-bold text-white text-xl">
                K
              </div>
              <div className="text-white">
                <div className="font-bold text-lg leading-tight">KWE Gebäudetechnik</div>
                <div className="text-xs text-gray-400">GmbH München</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              Ihr kompetenter Partner für moderne Gebäudetechnik in München und Umgebung.
            </p>
            {/* Social Media */}
            <div className="flex space-x-3">
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Leistungen</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('leistungen')}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200 text-sm"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="text-orange-500 flex-shrink-0 mt-1" size={18} />
                <span className="text-sm text-gray-400">
                  {companyInfo.address}<br />
                  {companyInfo.city}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-orange-500 flex-shrink-0" size={18} />
                <a href={`tel:${companyInfo.phone}`} className="text-sm text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-orange-500 flex-shrink-0" size={18} />
                <a href={`mailto:${companyInfo.email}`} className="text-sm text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {new Date().getFullYear()} {companyInfo.name}. Alle Rechte vorbehalten.
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                Impressum
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                Datenschutz
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                AGB
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                Cookie-Einstellungen
              </a>
            </div>
          </div>
          <div className="text-center mt-4 text-xs text-gray-500">
            Geschäftsführer: {companyInfo.managingDirector} | {companyInfo.tradeRegister}
          </div>
        </div>
      </div>
    </footer>
  );
};